<template>
  <div class="address_item box-shadow mt-4 mb-5">
    <!-- <span
      class="position-absolute select-section d-flex align-items-center"
      v-bind:class="selected ? 'selected' : null"
    >
      <div class="address_item_select">
        <div class="address_item_selected" v-show="selected"></div>
      </div>
    </span>-->

    <div class="address_item_title">
      <h5 class="title py-1 px-3 rounded">{{ address.title }}</h5>
    </div>

    <div class="p-3">
      <div class="row">
        <div class="col-xl-6 align-self-center">
          <div class="mb-4 my-4">
            <div class="py-2">{{ address.address }}</div>
            <div class="py-2">
              <span class="px-2">
                {{ address.tel }}
                <i class="fas fa-phone-alt"></i>
              </span>
              <span class="px-2">
                {{ address.mobile }}
                <i class="fas fa-mobile-alt"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="col-xl-6">
          <div class="leaflet-maps-warper position-relative" header-text="Leaflet Maps">
            <!-- {{currentRequest.lat}} - {{currentRequest.lng}} -->
            <address-map :lat="address.lat" :lng="address.lng"></address-map>
          </div>
        </div>
      </div>
    </div>

    <div class="buttons p-2 d-flex align-items-center justify-content-center position-absolute">
      <button class="btn btn-default" @click="(e)=>{e.stopPropagation() ;$emit('edit', address)}">
        <i class="fas fa-pencil-alt"></i>
      </button>

      <button class="btn btn-default" @click="(e)=>{e.stopPropagation() ;$emit('delete', address)}">
        <i class="fas fa-trash"></i>
      </button>
    </div>

    <div class="text-center" v-if="selectable">
      <button class="btn btn-danger rounded-pill btn-sm my-2" @click="$emit('select', address)"> انتخاب و ادامه خرید</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddressMap from "../../components/maps/leaflet-maps/AddressMap";

export default {
  name: "address-component",
  props: ["address", "onDelete", "onEdit", "selectable", "selected"],

  components: {
    AddressMap,
  },

  data() {
    return {};
  },

  mounted() {
    //
  },

  computed: {
    ...mapGetters({}),
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.address_item {
  position: relative;
  padding-top: 1rem;
}

.address_item_title {
  position: absolute;
  top: -15px;
  margin-left: auto;
  margin-right: auto;
  left: auto;
  right: 20px;
  text-align: center;
}

.address_item_title .title {
  display: inline-block;
  background-color: #ef394f;
  color: #fff;
  font-size: 1.1rem;
}
.buttons {
  position: absolute;
  bottom: 0;
  right: 0;
}
.buttons button {
  margin: 0 2px;
}

.leaflet-maps-warper {
  height: 200px;
  width: 100%;
  margin: 0;
}

.select-section {
  display: inline-block;
  background-color: #ef394f;
  border: 2px solid #fff;
  color: #fff;
  padding: 0.5rem;
  top: 0;
  bottom: 0;
}

.address_item_select {
  border: 2px solid #fff;
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.address_item_selected {
  background-color: #fff;
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 50%;
  display: inline-block;
}
</style>


